var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "success-a",
    d: "M14.3147321,7.97991071 C14.6319006,7.6822909 15.12882,7.6822909 15.4441964,7.97991071 C15.7418012,8.29539229 15.7418012,8.79240917 15.4441964,9.109375 L9.89508929,14.6584821 C9.73256214,14.8028266 9.53170963,14.8794643 9.33035714,14.8794643 C9.13000461,14.8794643 8.9291521,14.8028266 8.765625,14.6584821 L6.40848214,12.3013393 C6.11087735,11.9839992 6.11087735,11.4869823 6.40848214,11.171875 C6.72385855,10.8738809 7.22077799,10.8738809 7.53794643,11.171875 L9.33035714,12.9888393 L14.3147321,7.97991071 Z M11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 Z M11,20.4285714 C16.2072562,20.4285714 20.4285714,16.2072562 20.4285714,11 C20.4285714,5.79274379 16.2072562,1.57142857 11,1.57142857 C5.79274379,1.57142857 1.57142857,5.79274379 1.57142857,11 C1.57142857,16.2072562 5.79274379,20.4285714 11,20.4285714 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "success-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#success-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#52C41A",
    mask: "url(#success-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 -1 23)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b7831b08.svg";
export { ForwardRef as ReactComponent };